import { action } from 'satcheljs';

export const ignoreLinkExpirationInternal = action(
    'REFRESH_SHARING_TIPS_FOR_LINK',
    (linkId: string) => ({
        linkId: linkId,
    })
);
